export var ProofId;
!function(ProofId) {
    ProofId[ProofId.PADDING = 0] = "PADDING", ProofId[ProofId.DEPOSIT = 1] = "DEPOSIT", ProofId[ProofId.WITHDRAW = 2] = "WITHDRAW", ProofId[ProofId.SEND = 3] = "SEND", ProofId[ProofId.ACCOUNT = 4] = "ACCOUNT", ProofId[ProofId.DEFI_DEPOSIT = 5] = "DEFI_DEPOSIT", ProofId[ProofId.DEFI_CLAIM = 6] = "DEFI_CLAIM";
}(ProofId || (ProofId = {}));
